import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAuthContext } from '../utils/context/authContext';

const EmailVerification = () => {
  const router = useRouter();
  const { user }: any = useAuthContext();
  useEffect(() => {
    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const mode = urlObject.searchParams.get('mode');
    const oobCode = urlObject.searchParams.get('oobCode');
    if (mode === 'resetPassword') {
      router.push(`/reset-password?oobCode=${oobCode}`);
    } else if (mode === 'verifyEmail') {
      router.push(`/confirm-email?oobCode=${oobCode}`);
    }
  }, [user]);

  return (
    <>
      <div>Loading...</div>
    </>
  );
};

export default EmailVerification;
